// ========================================
// Widget: RRHH — Coste empresa del curso (barras por mes) y su cifra «Último mes»
// El coste empresa real de las nóminas subidas (ver Nóminas → Gastos del curso),
// separado en sueldos fijos y por horas; el mes en curso sale punteado.
// ========================================

window.DashboardWidgets = window.DashboardWidgets || {};
window.DashboardWidgets.rrhh = window.DashboardWidgets.rrhh || {};

window.DashboardWidgets.rrhh.costeCurso = function(ctx) {
    const { costByMonth = [], costCourse } = ctx;
    const max = Math.max(0, ...costByMonth.map(m => m.fixed + m.hourly));
    const short = n => n >= 1000 ? `${(n / 1000).toLocaleString('es-ES', { maximumFractionDigits: 1 })}k` : Math.round(n).toLocaleString('es-ES');
    const height = n => max ? Math.round(n / max * 90) : 0;
    const total = costByMonth.reduce((s, m) => s + m.fixed + m.hourly, 0);
    const cols = costByMonth.map(m => {
        const sum = m.fixed + m.hourly;
        if (sum > 0) return `<div class="rp-bar-col"><span class="rp-bar-value">${short(sum)}</span><span class="rp-bar-stack">
            <span class="rp-bar is-hourly" style="height: ${height(m.hourly)}px"></span><span class="rp-bar is-fixed" style="height: ${height(m.fixed)}px"></span></span></div>`;
        if (m.when === 0) return '<div class="rp-bar-col"><span class="rp-bar-value">En curso</span><span class="rp-bar-current"></span></div>';
        return '<div class="rp-bar-col"><span class="rp-bar-empty"></span></div>';
    }).join('');
    const inner = `
        <div class="rp-card-head">
            <h2 class="rp-card-title">Coste empresa del curso</h2>
            <button type="button" class="rp-card-link" ${UIEvents.attr("click", function(event,captured){if(typeof NominasUpload!=='undefined')NominasUpload.activeSection='gastos';App.navigate('nominas');}, [])}>Ver gastos del curso</button>
        </div>
        <div class="rp-legend">
            <span><span class="rp-swatch" style="background: var(--dnr-teal-700)"></span>Sueldos fijos</span>
            <span><span class="rp-swatch" style="background: var(--dnr-teal-400)"></span>Por horas</span>
            <span>Curso ${costCourse} / ${costCourse + 1}: <strong style="color: var(--dnr-ink)">${Utils.formatCurrency(total)}</strong></span>
        </div>
        <div class="rp-bars" role="img" aria-label="Coste empresa por mes del curso: ${costByMonth.map(m => `${m.label} ${Utils.formatCurrency(m.fixed + m.hourly)}`).join(', ')}">${cols}</div>
        <div class="rp-bar-labels">${costByMonth.map(m => `<span>${m.label.slice(0, 3)}</span>`).join('')}</div>`;
    return window.DashboardWidgets.rrhh.card(ctx, inner);
};

window.DashboardWidgets.rrhh.costeMes = function(ctx) {
    const { lastCost } = ctx;
    const inner = `
        <span class="rp-kpi-label">${lastCost ? `Coste empresa · ${Utils.sanitizeHTML(lastCost.label)}` : 'Coste empresa'}</span>
        <span class="rp-kpi-value">${lastCost ? Utils.formatCurrency(lastCost.cost) : '—'}</span>
        <span class="rp-muted">${lastCost ? `Último mes con nóminas · ${lastCost.count} ${lastCost.count === 1 ? 'nómina' : 'nóminas'}${lastCost.missing ? ` (${lastCost.missing} sin importe)` : ''}` : 'Aún no hay nóminas con coste empresa'}</span>`;
    return window.DashboardWidgets.rrhh.card(ctx, inner, { navigate: 'nominas' });
};
